// extracted by mini-css-extract-plugin
module.exports = {"msgSubjectInput":"Styles_msgSubjectInput__3BUfV"};